export default __webpack_public_path__ + "static/media/heron.a674f628.png";